import { InputRule } from "prosemirror-inputrules";
import type { DOMOutputSpec } from "prosemirror-model";
import uuid4 from "uuid/v4";

import { NodeExtension } from "../extension";

export default class HorizontalRule extends NodeExtension {
	get name() {
		return "horizontal_rule";
	}

	get node() {
		return {
			group: "block",
			defining: true,
			inline: false,
			atom: true,
			selectable: true,
			parseDOM: [{ tag: "hr" }],
			attrs: {
				blockId: { default: null },
			},
			toDOM(): DOMOutputSpec {
				return ["hr", { pmblock: "" }];
			},
		};
	}

	inputRules() {
		return [
			// the horizontal rule is only created with typing "<em dash>-" at the beginning of a line
			new InputRule(/^—-$/, (state, match, start, end) => {
				const { tr } = state;
				const horizontalRuleNode = state.schema.nodes.horizontal_rule.createAndFill({ blockId: uuid4() });
				if (!horizontalRuleNode) return tr;
				tr.delete(start, end); // delete the ---
				tr.insert(start - 1, horizontalRuleNode); // insert the horizontal rule before
				return tr;
			}),
		];
	}
}
